import { AttachingMethod, Attachment, AttachmentType } from '@wix/ambassador-funnel-chatbot-v1-session/types';

import {
  AttachingMethod as AttachingMethodClient,
  Attachment as AttachmentClient,
  AttachmentType as AttachmentTypeClient,
} from '../../../types';

const attachmentMethodMapper: Record<AttachingMethodClient, AttachingMethod> = {
  [AttachingMethodClient.Button]: AttachingMethod.BUTTON,
  [AttachingMethodClient.Drop]: AttachingMethod.DROP,
  [AttachingMethodClient.Paste]: AttachingMethod.PASTE,
};

export const attachmentMapper = (attachment: AttachmentClient): Attachment => {
  const { name, url, width, height, size, attachingMethod, mimeType } = attachment;
  const attachmentBase = {
    name,
    url,
    width,
    height,
    size,
    attachingMethod: attachmentMethodMapper[attachingMethod],
    ...(mimeType ? { mimeType } : {}),
  };

  // TODO(fix-attachment-mimetype-flow): Remove cast once @wix/ambassador-funnel-chatbot-v1-session is republished with mime_type in ui_state.proto
  if (attachment.type === AttachmentTypeClient.Video) {
    const { iconUrl, duration, format } = attachment;
    return { ...attachmentBase, iconUrl, duration, format, type: AttachmentType.VIDEO } as Attachment;
  } else {
    return { ...attachmentBase, type: AttachmentType.IMAGE } as Attachment;
  }
};
